var React = require( 'react' );
var createReactClass = require('create-react-class');
var Topic = require('./topic.jsx');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var Education = createReactClass({
  mixins: [PureRenderMixin],
  render: function(){
    var topics = this.props.education.map(function (topic, i) {
      return (
          <Topic
            sections={topic.sections}
            title={topic.title}
            arrival={topic.topic}
            key={'education-row-' + i} />
        );
    });
    return (
        <section id="information">
          <div className="row">
              <div className="small-12 column">
                {topics}
              </div>
          </div>
        </section>
    );
  }
});

module.exports = Education;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/education.jsx